var render = function render(){var _vm=this,_c=_vm._self._c;return (this.getFarm.camera)?_c('div',[_c('canvas',{ref:"canvas1",staticStyle:{"width":"100%"},style:({ height: _vm.height, borderRadius: _vm.radius })})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }